module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Latte.3fe6aa6d.jpg";